import axios from "axios"
import { User } from "~/types"

export enum LuxaforColor {
  RED = "ff0000",
  GREEN = "00ff00",
  OFF = "000000",
}

export const setLuxaforLight = async (user: User, color: LuxaforColor) => {
  if (!user?.luxafor_token) return

  await axios.post("/api/luxafor/color", { color: color })
}
